<nz-modal [nzVisible]="isVisible" [nzTitle]="modalTitle" [nzContent]="modalContent" [nzFooter]="modalFooter"
  nzWidth="1000px" (nzOnCancel)="handleCancel()">

  <ng-template #modalTitle>
    <div class="profile">
      <nz-avatar nzIcon="user" nzAlt="Avatar" class="bot-avatar" [nzSize]="80" [nzSrc]="quinnyAiAvatarUrl"></nz-avatar>
      <div class="description">
        <div class="main">What Quinny AI has to say?</div>
      </div>
    </div>
  </ng-template>

  <ng-template #modalContent>
    <nz-spin [nzSpinning]="loading">
      <div class="financial-content">
        <div class="header blue">Financial Ratio</div>

        <div>
          Your company, {{ data.companyName }}, has a Gross Profit Margin of
          <span class="blue">{{ data.gpmPercentage }}</span> and Net Profit Margin of
          <span class="blue">{{ data.npmPercentage }}</span> for the last month, {{ data.queryDate | customDate }}. As
          we benchmark against the {{ data.bizNatureName}} sector in the {{ data.fullCountry }}, the average Gross
          Profit Margin is
          <span class="blue">{{ data.industryGPMPercentage }}</span>, and the Net Profit Margin is
          <span class="blue">{{ data.industryNPMPercentage }}</span>.
          <br><br>
          It shows that {{ data.companyName }}'s Gross Profit Margin has a
          <span [ngClass]="colour(data.gpmVariance > 0)">{{ data.gpmVariancePercentage }}</span> variance compared to
          the average result of the {{ data.bizNatureName}} sector in the {{ data.fullCountry }}, while for Net Profit
          Margin, it shows a
          <span [ngClass]="colour(data.npmVariance > 0)">{{ data.npmVariancePercentage }}</span> difference<span
            *ngIf="data.gpmVariance >= 0 || data.npmVariance >= 0 ; else negativeResult">, demonstrating exceptionally
            impressive performance within the realm of {{ data.bizNatureName}} businesses in the {{ data.fullCountry }}.
            {{ data.companyName }} is making a significant impact in the {{ data.bizNatureName}} sector in the {{
            data.fullCountry }}, showcasing strong financial health and effective management.</span>
          <ng-template #negativeResult>
            <span>. These figures indicate that {{ data.companyName }}'s financial performance is significantly below
              the industry average, highlighting potential challenges in its financial health and management within the
              {{ data.bizNatureName}} in the {{ data.fullCountry }}.</span>
          </ng-template>
          <br><br>
          Here are some possible cause for why the Gross Profit Margin and Net Profit Margin of {{ data.bizNatureName}}
          in the {{ data.fullCountry }} is
          <span *ngIf="data.gpmVariance >= 0 || data.npmVariance >= 0">higher</span>
          <span *ngIf="data.gpmVariance < 0 && data.npmVariance < 0">lower</span> than the benchmark:
        </div>
      </div><br>
      <div class="advice-content">
        <div *ngIf="isAdvice" class="advise-header blue">Tips on how you can improve!</div>
        <div class="header blue"><u>Gross Profit Margin</u></div>
        <div *ngIf="isAdvice" class="content">
          <div [innerHTML]="gpm.advice"></div>
        </div>
        <div *ngIf="isInterpretation" class="content">
          <div [innerHTML]="gpm.interpret"></div>
        </div>
        <br>
        <div class="header blue"><u>Net Profit Margin</u></div>
        <div *ngIf="isAdvice" class="content">
          <div [innerHTML]="npm.advice"></div>
        </div>
        <div *ngIf="isInterpretation" class="content">
          <div [innerHTML]="npm.interpret"></div>
        </div>
        <br>
      </div>
      <div>
        <div>I hope this helps! Let me know if you have any other questions.</div>
        <br>
        <div class="disclaimer"><span class="blue">Disclaimer:</span>
          Please note that the results provided are based on gathered data from various articles. While efforts have
          been made to sure accuracy, we advise consulting financial database, industry reports, or government
          statistics for the latest information on this metric.</div>
      </div>
    </nz-spin>
  </ng-template>

  <ng-template #modalFooter>
    <div class="footer d-flex justify-content-between">
      <div *ngIf="!isAdvice" class="advice-tips" (click)="showContent()">
        <span nz-icon [nzIconfont]="'icon-question'"></span>
        <div class="text">Tips on how you can improve!</div>
      </div>
      <div *ngIf="isAdvice" class="advice-tips" (click)="showContent()">
        <div class="text">Back </div>
        <span nz-icon nzType="arrow-left" nzTheme="outline"></span>
      </div>

      <!-- <app-financial-ratio-lang-selection/> -->

      <div class="advisor">
        <nz-avatar nzIcon="user" nzAlt="Avatar" class="bot-avatar" [nzSize]="70"
          [nzSrc]="quinnyAiAvatarUrl"></nz-avatar>
        <div class="name">
          <div class="Qbot">Quinny AI</div>
          <div class="desc">QNE Financial Advisor</div>
        </div>
      </div>
    </div>
  </ng-template>

</nz-modal>